import Client from '../axios-client';

const resource = '/import/subaccount';

export default {
    getAll() {
        return Client.get(`${resource}`);
    },
};
